import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { AllCurrentExecutionsResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAllCurrentExecutions = (
  pageTable: number,
  resultsPerPage: number = 20
  // searchTerm?: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, AllCurrentExecutionsResponse>(
    ["executions", "current", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        // searchTerm,
      };

      // if (statuses) {
      //   query.executionStatuses = statuses.join(",");
      // }
      // if (!searchTerm) {
      //   delete query.searchTerm;
      // }
      const data = await axiosClient.get<AllCurrentExecutionsResponse>(
        `/execution/getAll/current?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      enabled: false,
    }
  );
};
